import * as cache from './cache';


const defaultOptions = {
  withCredentials: true,
  cache: true,
  withClientCache: true,
  headers: {},
};


export function encode(value) {
  return encodeURIComponent(value)
    .replace(/%40/gi, '@')
    .replace(/%3A/gi, ':')
    .replace(/%24/gi, '$')
    .replace(/%2C/gi, ',')
    .replace(/%20/gi, '+');
}

export function normalizeUrl(url) {
  return url.replace(/([a-z\-_0-9]+)\/\//gi, '$1/');
}

export function buildUrl(url, params) {
  if (!params) {
    return url;
  }

  const parts = _(params)
    .map(function (value, key) {
      if (_.isNil(value)) {
        return '';
      }

      if (_.isDate(value) && !isNaN(value.valueOf())) {
        value = value.toISOString();
      } else if (_.isObject(value)) {
        value = JSON.stringify(value);
      }

      return `${encode(key)}=${encode(value)}`;
    })
    .compact()
    .value();

  if (parts.length !== 0) {
    url += (_.includes(url, '?') ? '&' : '?') + parts.join('&');
  }

  return url;
}


function addCaching(sendRequest) {
  return function ({ method, url }) {
    const cachedPromise = cache.get(url);
    if (method === 'GET' && cachedPromise) {
      return cachedPromise;
    }

    const promise = sendRequest(...arguments);

    cache.setExpirable(url, promise);

    return promise;
  };
}


function sendRequest({ method, url, data, options }) {

  options = _.merge({}, defaultOptions, options);

  return new Promise(function (resolve, reject) {
    const request = new XMLHttpRequest();

    request.addEventListener('load', function () {
      if (/^2/.test(request.status)) {
        handlePromise(resolve)();
      } else {
        handlePromise(reject)();
      }
    });

    request.addEventListener('error', handlePromise(reject));
    request.addEventListener('abort', handlePromise(reject));


    const { cache, responseType, withCredentials, headers } = options;

    if (cache === false) {
      const cacheKiller = `_=${Date.now()}`;
      url += (_.includes(url, '?') ? '&' : '?') + cacheKiller;
    }

    request.open(method, url);

    if (responseType) {
      request.responseType = responseType;
    }
    request.withCredentials = withCredentials;

    _(headers)
      .keys()
      .forEach(function (name) {
        request.setRequestHeader(name, headers[name]);
      });

    request.send(data);

    function handlePromise(resolveReject) {
      return function () {
        const { status, responseText } = request;

        let data = responseText;
        try {
          data = JSON.parse(responseText);
        } catch (error) {
        }

        resolveReject({
          status,
          data,
          url,
        });
      };
    }
  });
}


function createRequestTriggerer(method = 'GET') {
  method = method.toUpperCase();

  return function (url, { params = null, data = null, options = defaultOptions } = {}) {

    if (data && _.isObject(data) && data instanceof FormData === false) {
      data = JSON.stringify(data);
    }

    url = buildUrl(url, params);
    url = normalizeUrl(url);

    const send = options.withClientCache ?
      addCaching(sendRequest) :
      sendRequest;

    return send({ method, url, data, options });
  };
}

export const get = createRequestTriggerer('GET');
export const post = createRequestTriggerer('POST');
export const put = createRequestTriggerer('PUT');
export const del = createRequestTriggerer('DELETE');

export default {
  get,
  post,
  put,
  del,
};



// WEBPACK FOOTER //
// ./src/transport/utils/http.js